(() => {
  const expandButtons = document.querySelectorAll("[data-sidebar-expand]");

  expandButtons.forEach((button) => {
    const section = button.closest(".sidebar-section");
    const extraItems = section?.querySelectorAll("[data-sidebar-expand-panel] .is-extra");

    if (!extraItems?.length) {
      button.hidden = true;
      return;
    }

    button.addEventListener("click", () => {
      extraItems.forEach((item) => {
        item.hidden = false;
      });
      button.hidden = true;
    });
  });
})();

(() => {
  const filterContainer = document.querySelector("[data-collection-filters]");
  const productCards = Array.from(document.querySelectorAll("[data-product-card]"));
  const resultCount = document.querySelector("[data-collection-result-count]");
  const emptyMessage = document.querySelector("[data-filter-empty]");
  const collectionHeading = document.querySelector("[data-collection-heading]");

  if (!filterContainer || !productCards.length) return;

  const notSelectedLabel = filterContainer.querySelector("[data-filter-summary]")?.textContent.trim() || "-";
  const countTemplate = resultCount?.dataset.countTemplate || "__COUNT__";
  const filterGroups = ["category", "purpose", "brand"];

  const normalize = (value) => value.trim().toLowerCase();
  const getInputValues = (input) => (input.dataset.filterValue || "").split("|").map(normalize).filter(Boolean);

  const getSelectedTerms = (group) =>
    Array.from(filterContainer.querySelectorAll(`[data-filter-group="${group}"]:checked`)).map((input) => {
      const values = getInputValues(input);

      return {
        label: input.closest("label")?.innerText.trim() || input.dataset.filterValue || "",
        value: values[0] || "",
        values,
      };
    });

  const getUrlTerms = (params, key) =>
    params
      .getAll(key)
      .flatMap((value) => value.split(","))
      .map(normalize)
      .filter(Boolean);

  const setSelectFromParams = (selector, params, keys) => {
    const select = filterContainer.querySelector(selector);
    if (!select) return;

    const value = keys.map((key) => params.get(key)).find(Boolean);
    if (!value) return;

    const hasOption = Array.from(select.options).some((option) => option.value === value);
    if (hasOption) {
      select.value = value;
    }
  };

  const applyFiltersFromUrl = () => {
    const params = new URLSearchParams(window.location.search);

    filterGroups.forEach((group) => {
      const requestedTerms = getUrlTerms(params, group);
      if (!requestedTerms.length) return;

      filterContainer.querySelectorAll(`[data-filter-group="${group}"]`).forEach((input) => {
        const shouldCheck = requestedTerms.some((term) => getInputValues(input).includes(term));
        input.checked = shouldCheck;

        if (shouldCheck) {
          const label = input.closest("label");
          if (label) {
            label.hidden = false;
            label.closest(".sidebar-section")?.querySelector("[data-sidebar-expand]")?.setAttribute("hidden", "");
          }
        }
      });
    });

    setSelectFromParams("[data-price-min]", params, ["price_min", "min_price"]);
    setSelectFromParams("[data-price-max]", params, ["price_max", "max_price"]);
  };

  const updateSummary = (group, selectedTerms) => {
    const summary = filterContainer.querySelector(`[data-filter-summary="${group}"]`);
    if (!summary) return;
    summary.textContent = selectedTerms.length ? selectedTerms.map((term) => term.label).join(" / ") : notSelectedLabel;
  };

  const updateHeading = (terms) => {
    if (!collectionHeading) return;

    if (!terms.length) {
      collectionHeading.textContent = collectionHeading.dataset.defaultHeading || collectionHeading.textContent;
      return;
    }

    const title = terms.map((term) => term.label).join(" / ");
    const template = collectionHeading.dataset.filteredHeadingTemplate || "__TITLE__";
    collectionHeading.textContent = template.replace("__TITLE__", title);
  };

  const matchesTerms = (filterText, terms) => {
    if (!terms.length) return true;
    return terms.some((term) => term.values.some((value) => filterText.includes(value)));
  };

  const getPrice = (card) => {
    const parsed = Number.parseFloat((card.dataset.productPrice || "").replace(/[^\d.]/g, ""));
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const updateProducts = () => {
    const categoryTerms = getSelectedTerms("category");
    const purposeTerms = getSelectedTerms("purpose");
    const brandTerms = getSelectedTerms("brand");
    const minPrice = Number.parseFloat(filterContainer.querySelector("[data-price-min]")?.value || "");
    const maxPrice = Number.parseFloat(filterContainer.querySelector("[data-price-max]")?.value || "");

    let visibleCount = 0;

    productCards.forEach((card) => {
      const categoryFilterText = normalize(card.dataset.filterCategory || "");
      const purposeFilterText = normalize(card.dataset.filterPurpose || "");
      const brandFilterText = normalize(card.dataset.filterBrand || "");
      const price = getPrice(card);
      const matches =
        matchesTerms(categoryFilterText, categoryTerms) &&
        matchesTerms(purposeFilterText, purposeTerms) &&
        matchesTerms(brandFilterText, brandTerms) &&
        (!Number.isFinite(minPrice) || price >= minPrice) &&
        (!Number.isFinite(maxPrice) || price <= maxPrice);

      card.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    updateSummary("category", categoryTerms);
    updateSummary("brand", brandTerms);
    updateHeading([...categoryTerms, ...purposeTerms, ...brandTerms]);

    if (resultCount) {
      resultCount.textContent = countTemplate.replace("__COUNT__", String(visibleCount));
      resultCount.dataset.filteredCount = String(visibleCount);
    }

    if (emptyMessage) {
      emptyMessage.hidden = visibleCount > 0;
    }
  };

  const updateUrl = () => {
    if (!window.history?.replaceState) return;

    const nextUrl = new URL(window.location.href);
    filterGroups.forEach((group) => {
      const values = getSelectedTerms(group)
        .map((term) => term.value)
        .filter(Boolean);
      nextUrl.searchParams.delete(group);

      if (values.length) {
        nextUrl.searchParams.set(group, values.join(","));
      }
    });

    const priceMin = filterContainer.querySelector("[data-price-min]")?.value || "";
    const priceMax = filterContainer.querySelector("[data-price-max]")?.value || "";
    nextUrl.searchParams.delete("price_min");
    nextUrl.searchParams.delete("price_max");
    nextUrl.searchParams.delete("min_price");
    nextUrl.searchParams.delete("max_price");

    if (priceMin) nextUrl.searchParams.set("price_min", priceMin);
    if (priceMax) nextUrl.searchParams.set("price_max", priceMax);

    window.history.replaceState({}, "", nextUrl);
  };

  filterContainer.addEventListener("change", (event) => {
    if (event.target.matches("[data-filter-group], [data-price-min], [data-price-max]")) {
      updateProducts();
      updateUrl();
    }
  });

  applyFiltersFromUrl();
  updateProducts();
})();

(() => {
  const sortForms = document.querySelectorAll("[data-collection-sort-form]");

  sortForms.forEach((form) => {
    const sortSelect = form.querySelector('select[name="sort_by"]');
    if (!sortSelect) return;

    sortSelect.addEventListener("change", () => {
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set("sort_by", sortSelect.value);
      window.location.href = nextUrl.toString();
    });
  });
})();

(() => {
  const sliders = document.querySelectorAll("[data-hero-slider]");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  sliders.forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll("[data-hero-slide]"));
    const previousButton = slider.querySelector("[data-slider-prev]");
    const nextButton = slider.querySelector("[data-slider-next]");

    if (slides.length < 2) return;

    let currentIndex = Math.max(
      slides.findIndex((slide) => slide.classList.contains("is-active")),
      0,
    );
    let timerId;

    const showSlide = (index) => {
      currentIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === currentIndex;
        slide.classList.toggle("is-active", isActive);
        slide.setAttribute("aria-hidden", String(!isActive));
      });
    };

    const stopAutoplay = () => {
      window.clearInterval(timerId);
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (reduceMotion.matches) return;
      timerId = window.setInterval(() => showSlide(currentIndex + 1), 5200);
    };

    previousButton?.addEventListener("click", () => {
      showSlide(currentIndex - 1);
      startAutoplay();
    });

    nextButton?.addEventListener("click", () => {
      showSlide(currentIndex + 1);
      startAutoplay();
    });

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    reduceMotion.addEventListener("change", startAutoplay);
    showSlide(currentIndex);
    startAutoplay();
  });
})();

(() => {
  const contactForms = document.querySelectorAll("[data-contact-form]");

  contactForms.forEach((form) => {
    const fields = form.querySelector("[data-contact-fields]");
    const review = form.querySelector("[data-contact-review]");
    const backButton = form.querySelector("[data-contact-back]");
    const submitButton = form.querySelector("[data-contact-submit]");
    const inputStep = form.querySelector('[data-contact-step="input"]');
    const confirmStep = form.querySelector('[data-contact-step="confirm"]');
    const emailField = form.querySelector("#ContactFormEmail");
    const emailConfirmField = form.querySelector("#ContactFormEmailConfirm");

    if (!fields || !review || !submitButton) return;

    const confirmLabel = submitButton.dataset.confirmLabel || submitButton.textContent.trim();
    const sendLabel = submitButton.dataset.sendLabel || "Send";
    const emailMismatchMessage = emailConfirmField?.dataset.emailMismatch || "Email confirmation does not match.";

    const getSummaryValue = (row) => {
      const checkedField = row.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
      if (checkedField) return checkedField.value.trim();

      const field = row.querySelector("textarea, input, select");
      if (!field) return "";

      return field.value.trim();
    };

    const setStep = (isConfirming) => {
      inputStep?.classList.toggle("is-active", !isConfirming);
      confirmStep?.classList.toggle("is-active", isConfirming);
    };

    const showInput = () => {
      form.dataset.contactConfirmed = "false";
      form.classList.remove("is-confirming");
      review.hidden = true;
      backButton.hidden = true;
      submitButton.textContent = confirmLabel;
      setStep(false);
    };

    const showReview = () => {
      const summaryRows = Array.from(fields.querySelectorAll("[data-contact-summary]"));
      const summaryList = document.createElement("dl");

      summaryRows.forEach((row) => {
        const item = document.createElement("div");
        const term = document.createElement("dt");
        const description = document.createElement("dd");

        term.textContent = row.dataset.contactSummary || "";
        description.textContent = getSummaryValue(row) || "-";
        item.append(term, description);
        summaryList.append(item);
      });

      review.replaceChildren(summaryList);
      review.hidden = false;
      backButton.hidden = false;
      submitButton.textContent = sendLabel;
      form.dataset.contactConfirmed = "true";
      form.classList.add("is-confirming");
      setStep(true);
    };

    const validateForm = () => {
      emailConfirmField?.setCustomValidity("");
      if (emailField && emailConfirmField && emailField.value.trim() !== emailConfirmField.value.trim()) {
        emailConfirmField.setCustomValidity(emailMismatchMessage);
      }

      return form.reportValidity();
    };

    const handleConfirmIntent = (event) => {
      if (form.dataset.contactConfirmed === "true") return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!validateForm()) {
        return;
      }

      showReview();
    };

    emailField?.addEventListener("input", () => {
      emailConfirmField?.setCustomValidity("");
    });

    emailConfirmField?.addEventListener("input", () => {
      emailConfirmField.setCustomValidity("");
    });

    submitButton.addEventListener("click", handleConfirmIntent, { capture: true });
    form.addEventListener("submit", handleConfirmIntent, { capture: true });
    backButton?.addEventListener("click", (event) => {
      event.preventDefault();
      showInput();
    });
    showInput();
  });
})();

(() => {
  const quantitySteppers = document.querySelectorAll(".product-quantity-stepper");

  quantitySteppers.forEach((stepper) => {
    const input = stepper.querySelector('input[name="quantity"]');
    const minusButton = stepper.querySelector("[data-quantity-minus]");
    const plusButton = stepper.querySelector("[data-quantity-plus]");

    if (!input) return;

    const getCurrentValue = () => Math.max(Number(input.value) || 1, Number(input.min) || 1);

    minusButton?.addEventListener("click", () => {
      input.value = String(Math.max(getCurrentValue() - 1, Number(input.min) || 1));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    plusButton?.addEventListener("click", () => {
      input.value = String(getCurrentValue() + 1);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });
})();

(() => {
  const productForms = document.querySelectorAll("[data-product-variant-form]");

  productForms.forEach((form) => {
    const variantInput = form.querySelector("[data-selected-variant-id]");
    const priceTarget = form.querySelector("[data-selected-variant-price]");
    const submitButton = form.querySelector("[data-ajax-cart-submit]");
    const variantButtons = Array.from(form.querySelectorAll("[data-variant-selector]"));

    if (!variantInput || !variantButtons.length) return;

    const applyVariant = (button) => {
      const variantId = button.dataset.variantId;
      if (!variantId || button.disabled) return;

      variantInput.value = variantId;
      variantButtons.forEach((relatedButton) => {
        const isSelected = relatedButton === button;
        relatedButton.classList.toggle("is-active", isSelected);
        relatedButton.setAttribute("aria-pressed", String(isSelected));
      });

      if (priceTarget && button.dataset.variantPrice) {
        priceTarget.textContent = button.dataset.variantPrice;
      }

      if (submitButton) {
        submitButton.disabled = button.dataset.variantAvailable === "false";
      }

      if (window.history?.replaceState) {
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set("variant", variantId);
        window.history.replaceState({}, "", nextUrl);
      }
    };

    variantButtons.forEach((button) => {
      button.addEventListener("click", () => applyVariant(button));
    });
  });
})();

(() => {
  const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
  const cartCountBadges = document.querySelectorAll("[data-cart-count]");

  if (!addToCartForms.length) return;

  const getRootPath = () => window.Shopify?.routes?.root || "/";

  const setCartCount = (count) => {
    cartCountBadges.forEach((badge) => {
      badge.textContent = String(count);
      badge.dataset.cartCount = String(count);
    });
  };

  const refreshCartCount = async () => {
    const response = await fetch(`${getRootPath()}cart.js`, {
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) return;

    const cart = await response.json();
    setCartCount(cart.item_count || 0);
  };

  addToCartForms.forEach((form) => {
    form.addEventListener("submit", async (event) => {
      const submitButton = form.querySelector("[data-ajax-cart-submit]");
      if (!submitButton) return;

      event.preventDefault();

      const labelElement = submitButton.querySelector("span") || submitButton;
      const originalLabel = submitButton.dataset.originalLabel || labelElement.textContent.trim();
      submitButton.dataset.originalLabel = originalLabel;
      submitButton.disabled = true;
      labelElement.textContent = submitButton.dataset.addingLabel || originalLabel;

      try {
        const response = await fetch(`${getRootPath()}cart/add.js`, {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          body: new FormData(form),
        });

        if (!response.ok) throw new Error("Cart add failed");

        await refreshCartCount();
        labelElement.textContent = submitButton.dataset.addedLabel || originalLabel;
        window.setTimeout(() => {
          labelElement.textContent = originalLabel;
          submitButton.disabled = false;
        }, 1400);
      } catch (_error) {
        labelElement.textContent = submitButton.dataset.errorLabel || originalLabel;
        window.setTimeout(() => {
          labelElement.textContent = originalLabel;
          submitButton.disabled = false;
        }, 1800);
      }
    });
  });

  refreshCartCount();
})();

(() => {
  const favoriteButtons = document.querySelectorAll("[data-favorite-toggle]");
  const storageKey = "draft-shop-favorites";

  if (!favoriteButtons.length) return;

  const readFavorites = () => {
    try {
      return new Set(JSON.parse(window.localStorage.getItem(storageKey) || "[]"));
    } catch (_error) {
      return new Set();
    }
  };

  const writeFavorites = (favorites) => {
    window.localStorage.setItem(storageKey, JSON.stringify(Array.from(favorites)));
  };

  const applyState = (button, favorites) => {
    const isFavorite = favorites.has(button.dataset.productHandle);
    button.setAttribute("aria-pressed", String(isFavorite));
    button.classList.toggle("is-active", isFavorite);
  };

  const favorites = readFavorites();

  favoriteButtons.forEach((button) => {
    applyState(button, favorites);

    button.addEventListener("click", () => {
      const handle = button.dataset.productHandle;
      if (!handle) return;

      if (favorites.has(handle)) {
        favorites.delete(handle);
      } else {
        favorites.add(handle);
      }

      writeFavorites(favorites);

      favoriteButtons.forEach((relatedButton) => {
        if (relatedButton.dataset.productHandle === handle) {
          applyState(relatedButton, favorites);
        }
      });
    });
  });
})();
